import React, { useState, useEffect } from 'react';
import './BlogStickySignup.css';

const BlogStickySignup = ({ title = "Want to build your own trading bot?" }) => {
  const [isVisible, setIsVisible] = useState(false);
  const [userClosedForm, setUserClosedForm] = useState(false);

  useEffect(() => {
    // Show form after a fixed delay with no scroll tracking
    const timer = setTimeout(() => {
      setIsVisible(true);
    }, 15000); // 15 seconds
    
    return () => {
      clearTimeout(timer);
    };
  }, []);

  const handleDirectRedirect = () => {
    // Go directly to sales page in a new tab
    window.open('/sales', '_blank', 'noopener,noreferrer');
  };

  const handleClose = () => {
    setIsVisible(false);
    setUserClosedForm(true);
  };

  // Don't show component if user closed it or it's not yet visible
  if (!isVisible || userClosedForm) {
    return null;
  }

  return (
    <div className="blog-sticky-signup">
      <button className="blog-sticky-close" onClick={handleClose}>×</button>
      <h3>{title}</h3>
      <p>Start your free trial now and create profitable algorithms in seconds!</p>
      <button onClick={handleDirectRedirect} className="blog-sticky-button">
        Get Free Trial
      </button>
    </div>
  );
};

export default BlogStickySignup;
